import { Component, Input, OnInit } from "@angular/core";
import { UiErrorService } from "../service/ui-error-service/ui-error.service";
import { UiError } from "../service/ui-error.factory";
import { CommonModule } from "@angular/common";
import { Observable } from "rxjs";

@Component({
  selector: "app-error-banner",
  imports: [CommonModule],
  templateUrl: "./error-banner.component.html",
  styleUrl: "./error-banner.component.scss"
})
export class ErrorBannerComponent implements OnInit {
  error$: Observable<UiError>;

  constructor(
    private uiErrorService: UiErrorService
  ) {
  }

  ngOnInit(): void {
    this.error$ = this.uiErrorService.error$;
  }

  dismiss() {
    this.uiErrorService.clear();
    window.location.reload();
  }
}